// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./CourseImages/backgroundTestimonal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./CourseImages/Khawaja_Mujtba_Sahaf.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./CourseImages/Wahab_Omer.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./CourseImages/Elina_Kumar.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./CourseImages/Saadia_Aftab.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./CourseImages/Eman.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./CourseImages/MUSTAFA.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./CourseImages/Abdul_hadi.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./CourseImages/Minahil_Jahanzeb.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./CourseImages/Zahra_Umair.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./CourseImages/Amal.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./CourseImages/Haris.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./CourseImages/Carl_Adrianne N.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./CourseImages/Philip.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./CourseImages/Faith.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./CourseImages/testimonalGamedev.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Testimonal_Heading{
	color: #333;
	text-align: center;
	text-transform: uppercase;
	font-family: "Roboto", sans-serif;
	font-weight: bold;
	position: relative;
	margin: 30px 0 60px;
}

.col-center {
	margin: 0 auto;
	float: none !important;
}
.carousel {
	padding: 0 70px;
}
.carousel .carousel-item {
	color: #999;
	font-size: 14px;
	text-align: center;
	overflow: hidden;
	min-height: 290px;
}
.backgroundtest{ 
    width: 100%;
    height:500px; 
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover; 
    position: relative;
}
.carousel .carousel-item .imge-box1 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_1___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}

.carousel .carousel-item .imge-box2 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_2___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box3 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_3___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box4 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_4___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box5 {
	background:  url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box6 {
    
	background:  url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box7 {
    
	background:  url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box8 {
    
	background:  url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box9 {
    
	background:  url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box10 {
    
	background:  url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box11 {
    
	background:  url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box12 {
    
	background:  url(${___CSS_LOADER_URL_REPLACEMENT_12___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box13 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_13___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box14 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_14___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .carousel-item .imge-box15 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_15___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .img-box img {

	width: 100%;
	height: 100%;
	display: block;
	border-radius: 50%;
}
.carousel .testimonial {
	padding: 30px 0 10px;
}
.carousel .overview {	
	font-style: italic;
}
.carousel .overview b {
	text-transform: uppercase;
	color: #7AA641;
}
.carousel-control-prev, .carousel-control-next {
	width: 40px;
	height: 40px;
	margin-top: -20px;
	top: 50%;
	background: none;
}
.carousel-control-prev i, .carousel-control-next i {
	font-size: 68px;
	line-height: 42px;
	position: absolute;
	display: inline-block;
	color: rgba(0, 0, 0, 0.8);
	text-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;
}
.carousel-indicators {
	bottom: -40px;
}
.carousel-indicators li, .carousel-indicators li.active {
	width: 12px;
	height: 12px;
	margin: 1px 3px;
	border-radius: 50%;
	border: none;
}
.carousel-indicators li {	
	background: #999;
	border-color: transparent;
	box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
}
.carousel-indicators li.active {	
	background: #555;		
	box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
}

`, "",{"version":3,"sources":["webpack://./src/MyComponents/Testimonials.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,kBAAkB;CAClB,yBAAyB;CACzB,iCAAiC;CACjC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,sBAAsB;AACvB;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oDAA2D;IAC3D,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,oDAA4D;;IAE5D,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;IACI,oDAAkD;;IAElD,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;IACI,oDAAmD;;IAEnD,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;IACI,oDAAoD;;IAEpD,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;CACC,oDAA4C;IACzC,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,oDAA+C;IAC5C,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,oDAAkD;IAC/C,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,oDAAwD;IACrD,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,oDAAmD;IAChD,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,qDAA4C;IACzC,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,qDAA6C;IAC1C,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,qDAAsD;;IAEnD,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;IACI,qDAA6C;;IAE7C,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;IACI,qDAA4C;;IAE5C,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;IACI,qDAAwD;;IAExD,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,QAAQ;CACR,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,yBAAyB;CACzB,0CAA0C;AAC3C;AACA;CACC,aAAa;AACd;AACA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,2CAA2C;AAC5C;AACA;CACC,gBAAgB;CAChB,2CAA2C;AAC5C","sourcesContent":[".Testimonal_Heading{\n\tcolor: #333;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\tfont-family: \"Roboto\", sans-serif;\n\tfont-weight: bold;\n\tposition: relative;\n\tmargin: 30px 0 60px;\n}\n\n.col-center {\n\tmargin: 0 auto;\n\tfloat: none !important;\n}\n.carousel {\n\tpadding: 0 70px;\n}\n.carousel .carousel-item {\n\tcolor: #999;\n\tfont-size: 14px;\n\ttext-align: center;\n\toverflow: hidden;\n\tmin-height: 290px;\n}\n.backgroundtest{ \n    width: 100%;\n    height:500px; \n    background:  url('./CourseImages/backgroundTestimonal.png');\n    background-size: cover; \n    position: relative;\n}\n.carousel .carousel-item .imge-box1 {\n    background:  url('./CourseImages/Khawaja_Mujtba_Sahaf.jpeg');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n\n.carousel .carousel-item .imge-box2 {\n    background:  url('./CourseImages/Wahab_Omer.jpeg');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box3 {\n    background:  url('./CourseImages/Elina_Kumar.jpeg');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box4 {\n    background:  url('./CourseImages/Saadia_Aftab.jpeg');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box5 {\n\tbackground:  url('./CourseImages/Eman.jpeg');\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box6 {\n    \n\tbackground:  url('./CourseImages/MUSTAFA.jpeg');\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box7 {\n    \n\tbackground:  url('./CourseImages/Abdul_hadi.jpeg');\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box8 {\n    \n\tbackground:  url('./CourseImages/Minahil_Jahanzeb.jpeg');\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box9 {\n    \n\tbackground:  url('./CourseImages/Zahra_Umair.jpeg');\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box10 {\n    \n\tbackground:  url('./CourseImages/Amal.jpeg');\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box11 {\n    \n\tbackground:  url('./CourseImages/Haris.jpeg');\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box12 {\n    \n\tbackground:  url('./CourseImages/Carl_Adrianne N.jpg');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box13 {\n    background:  url('./CourseImages/Philip.png');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box14 {\n    background:  url('./CourseImages/Faith.png');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .carousel-item .imge-box15 {\n    background:  url('./CourseImages/testimonalGamedev.png');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .img-box img {\n\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\tborder-radius: 50%;\n}\n.carousel .testimonial {\n\tpadding: 30px 0 10px;\n}\n.carousel .overview {\t\n\tfont-style: italic;\n}\n.carousel .overview b {\n\ttext-transform: uppercase;\n\tcolor: #7AA641;\n}\n.carousel-control-prev, .carousel-control-next {\n\twidth: 40px;\n\theight: 40px;\n\tmargin-top: -20px;\n\ttop: 50%;\n\tbackground: none;\n}\n.carousel-control-prev i, .carousel-control-next i {\n\tfont-size: 68px;\n\tline-height: 42px;\n\tposition: absolute;\n\tdisplay: inline-block;\n\tcolor: rgba(0, 0, 0, 0.8);\n\ttext-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;\n}\n.carousel-indicators {\n\tbottom: -40px;\n}\n.carousel-indicators li, .carousel-indicators li.active {\n\twidth: 12px;\n\theight: 12px;\n\tmargin: 1px 3px;\n\tborder-radius: 50%;\n\tborder: none;\n}\n.carousel-indicators li {\t\n\tbackground: #999;\n\tborder-color: transparent;\n\tbox-shadow: inset 0 2px 1px rgba(0,0,0,0.2);\n}\n.carousel-indicators li.active {\t\n\tbackground: #555;\t\t\n\tbox-shadow: inset 0 2px 1px rgba(0,0,0,0.2);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
